export type ResultsView = 'results' | 'restarted' | 'home' | 'history';

/** Что показывать на маршруте итогов.
 *
 *  Сводка живёт в памяти, и любое действие на этом экране её обнуляет:
 *  «Повторить ошибки» заводит новую сессию, «Готово» сбрасывает состояние.
 *  Охранник, который на пустую сводку просто перенаправляет в историю,
 *  срабатывает в тот же кадр и обгоняет переход, задуманный кнопкой, —
 *  повтор ошибок уводил в историю вместо тренировки.
 *
 *  Поэтому решение принимается не по одному признаку, а по трём, и каждый
 *  случай назван:
 *
 *  - сводка на месте — показываем итоги;
 *  - сводки нет, но идёт тренировка — её только что начал повтор ошибок;
 *  - сводки нет, тренировки нет, но итоги уже показывались — нажато
 *    «Готово», уходим на главный экран;
 *  - сводки не было вовсе — это перезагрузка страницы. Сессия записана,
 *    показать её можно только из истории. */
export function resultsView(
  hasMatchingSummary: boolean,
  training: boolean,
  everShown: boolean,
): ResultsView {
  if (hasMatchingSummary) return 'results';
  if (training) return 'restarted';
  if (everShown) return 'home';
  return 'history';
}
